export const HIDE_EMAIL_REGEX = /(.{1})(.*)(?=@)(.{1})(.*)(?=\.)(.*)/g;
export const NUMBER_REGEX = /\d+/g;
export const UPPER_CASE_REGEX = /[A-Z]+/g;
export const SYMBOL_REGEX = /\W+/g;
